import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { companyNumbersQueryKeys } from "../query/company-numbers.queries";
import { CompanyNumber } from "@components/virtual-receptionist/widget";
import { getCompanyNumbers } from "../actions/get-company-number.actions";
import { useAppSelector } from "src/redux/hooks/redux";
import { selectCurrentCompany } from "src/redux/features/user/selectors/userState.selectors";

export const useCompanyNumberQuery = () => {
    const company = useAppSelector(selectCurrentCompany);

    const query = useQuery<CompanyNumber[]>({
        queryKey: companyNumbersQueryKeys.byCompanyId(company?.id!),
        queryFn: async () => await getCompanyNumbers(),
        retry: 0,
        staleTime: 60_000,
        placeholderData: keepPreviousData,
    })

    return query
}